<dm-sidebar-provider #sidebarProvider (dmOpenChange)="sidebarExpanded.set($event.detail)">
  <lp-sidebar-navigation
    [collapsed]="!sidebarExpanded()"
    [faqOpen]="faqOpen()"
    (faqRequested)="faqOpen.set(true)"
    [kontaktOpen]="kontaktOpen()"
    (kontaktRequested)="openContact()"
  />
  <dm-sidebar-inset>
    <dm-sidebar-mobile-header>
      <lp-logo slot="logo" variant="full" />
    </dm-sidebar-mobile-header>
    @if (showPasswordExpirationWarning()) {
      <dm-alert
        color="error"
        alertstyle="inline"
        [initialvisible]="true"
        i18n-morebuttonlabel="@@user.passwordExpiration.changePasswordAction"
        morebuttonlabel="Passwort ändern"
        [dismissbuttonlabel]="''"
        (dmAlertMoreClick)="goToProfilePassword()"
        (dmAlertCloseClick)="passwordAlertClosed()"
      >
        <!-- prettier-ignore -->
        <p slot="text" i18n="@@user.passwordExpiration.hinweis">{passwordExpirationRemainingDays(), plural,
          =0 {Ihr Passwort läuft heute ab. Sie können es jetzt oder beim nächsten Login ändern.}
          =1 {Ihr Passwort läuft morgen ab. Sie können es jetzt oder beim nächsten Login ändern.}
          other {Ihr Passwort läuft in {{ passwordExpirationRemainingDays() }} Tagen ab. Sie können es jetzt oder beim nächsten Login ändern.}
        }</p>
      </dm-alert>
    }
    <router-outlet />
  </dm-sidebar-inset>
</dm-sidebar-provider>
<lp-faq-drawer [(isOpen)]="faqOpen" (contactRequested)="openContact()" />
<lp-kontakt-modal [isModalOpen]="kontaktOpen()" (closeClick)="kontaktOpen.set(false)" />
